<template>
  <page :manualInit="schemeMenuInit.init" :manualErr="schemeMenuInit.initErr" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ schemeCode }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-list class="pt-0">
                <v-list-tile v-if="(newScheme !== true && checkAccess(['travelRatingReview']))" key="familyPlan" :to="{ name: 'familyPlan', params: { scheme: this.scheme } }">
                  <v-list-tile-action>
                    <v-icon>mdi-sofa</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Family Plan</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
// import { expandURI } from '@/utils/ajax'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'schemeReview', text: 'Scheme', icon: 'mdi-receipt', params: { scheme: this.scheme } },
        { name: 'schemeDurationList', text: 'Scheme Duration', icon: 'mdi-calendar-range', params: { scheme: this.scheme } },
        { name: 'pkgMenu', text: 'Package', icon: 'mdi-checkbox-multiple-marked', params: { scheme: this.scheme } },
        // No need to hide first
        { name: 'pkgTariff', text: 'Tariff', icon: 'mdi-function', params: { scheme: this.scheme } },
        { name: 'pkgStdText', text: 'Standard Text', icon: 'mdi-format-text', params: { scheme: this.scheme } },
        { name: 'pkgOptCvr', text: 'Optional Coverage', icon: 'mdi-shape-square-plus', params: { scheme: this.scheme } }
      ],
      newScheme: false,
      showRisk: false,
      showPlan: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    schemeCode() {
      if (this.scheme !== 'new') {
        return this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle
      } else {
        return 'New Scheme'
      }
    },
    schemeMenuInit() {
      return this.$store.state.parameters.scheme
    },
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async doInit() {
      if (this.scheme === 'new') {
        this.newScheme = true
        this.sideMenu = []
        this.sideMenu = [
          { name: 'schemeReview', text: 'Scheme', icon: 'mdi-receipt', params: { scheme: this.scheme } }
        ]
      } else {
        this.newScheme = false
        await this.$store.dispatch('schemeMenuInit', this.scheme)
      }
    }
  },
  created() {
    if (this.scheme !== 'new') {
      this.doInit()
    } else {
      this.newScheme = true
      this.sideMenu = [
        { name: 'schemeReview', text: 'Scheme', icon: 'mdi-receipt', params: { scheme: this.scheme } }
      ]
    }
  },
  props: {
    scheme: {
      type: String,
      default: ''
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
</style>
